import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { LayoutDashboard, Gamepad2, UtensilsCrossed, ScrollText, Zap } from 'lucide-react';

const nav = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, exact: true, testid: 'nav-dashboard' },
  { to: '/rental', label: 'Rental PS', icon: Gamepad2, testid: 'nav-rental' },
  { to: '/makanan', label: 'Makanan', icon: UtensilsCrossed, testid: 'nav-makanan' },
  { to: '/riwayat', label: 'Riwayat', icon: ScrollText, testid: 'nav-riwayat' },
];

export const Layout = () => {
  return (
    <div className="min-h-screen bg-[#090D16] text-slate-100">
      {/* Header */}
      <header className="sticky top-0 z-40 backdrop-blur-md bg-[#090D16]/85 border-b border-cyan-500/20">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan-400 to-fuchsia-500 flex items-center justify-center shadow-[0_0_18px_rgba(0,240,255,0.35)]">
              <Zap className="w-5 h-5 text-[#090D16]" strokeWidth={3} />
            </div>
            <div>
              <h1 className="font-display text-lg sm:text-xl font-extrabold tracking-tight leading-none">
                <span className="text-cyan-400">PLAY</span>
                <span className="text-slate-300">-</span>
                <span className="text-fuchsia-500">OMSET</span>
              </h1>
              <p className="text-[10px] sm:text-xs text-slate-500 font-mono-tactical uppercase tracking-widest">Sistem Kasir Rental PS</p>
            </div>
          </div>
          <div className="hidden md:flex items-center gap-2 text-xs font-mono-tactical text-slate-400 uppercase tracking-widest">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse shadow-[0_0_8px_#39FF14]" />
            System Online
          </div>
        </div>

        {/* Nav */}
        <nav className="max-w-[1400px] mx-auto px-4 sm:px-6 pb-3 flex gap-2 overflow-x-auto">
          {nav.map(({ to, label, icon: Icon, exact, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={exact}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap ${
                  isActive
                    ? 'bg-cyan-500/15 text-cyan-300 border border-cyan-400/50 shadow-[0_0_15px_rgba(0,240,255,0.2)]'
                    : 'text-slate-400 border border-transparent hover:text-slate-100 hover:bg-slate-800/40'
                }`
              }
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="max-w-[1400px] mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
